import { REDUCER } from '../reducers/reducersConst';

let initialState = {
  courseId: '',
  contentType: '',
  content: {}
};

export let googleClassroom = (state = initialState, action) => {
  switch (action.type) {
    case REDUCER.GOOGLE_CLASSROOM.SET_COURSE_ID:
      return {
        ...state,
        courseId: action.courseId
      };
    case REDUCER.GOOGLE_CLASSROOM.SET_CONTENT:
      return {
        ...state,
        content: action.content,
        contentType: action.contentType
      };
    case REDUCER.GOOGLE_CLASSROOM.CLEAR_COURSE_ID:
      return {
        ...state,
        courseId: ''
      };
    case REDUCER.GOOGLE_CLASSROOM.CLEAR_CONTENT:
      return {
        ...state,
        content: {},
        contentType: ''
      };
    default:
      return state;
  }
};
